export default "__VITE_ASSET__c7uoHWYo__"